import script from "./safetyInspection.vue?vue&type=script&setup=true&lang=js"
export * from "./safetyInspection.vue?vue&type=script&setup=true&lang=js"

import "./safetyInspection.vue?vue&type=style&index=0&id=535546a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535546a8"]])

export default __exports__